(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAnnouncementDelivery() {
      var els = document.querySelectorAll('[data-delivery-announcement]');
      if (!els.length) return;
      var dataEl = document.getElementById('delivery-settings-data');
      if (!dataEl || !window.TCSDelivery) return;
      var opts;
      try { opts = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var res = window.TCSDelivery.computeAvailability(new Date(), opts);
      if (!res.floor) return;
      var d = new Date(res.floor + 'T00:00:00Z');
      var label = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
      els.forEach(function (el) { el.textContent = label; });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAnnouncementDelivery);
    else initAnnouncementDelivery();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.shop-card [data-product-add]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const idInput = form.querySelector('input[name="id"]');
    if (!button || !idInput) {
      form.submit();
      return;
    }

    const originalLabel = button.textContent;
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: idInput.value, quantity: 1 }),
      });
      if (!response.ok) throw new Error('Add to cart failed');

      button.textContent = 'Added ✓';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      setTimeout(() => {
        button.textContent = originalLabel;
        button.disabled = false;
      }, 1800);
    } catch (error) {
      form.submit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-add]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const idInput = form.querySelector('input[name="id"]');
    if (!button || !idInput) {
      form.submit();
      return;
    }

    const originalLabel = button.textContent;
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: idInput.value, quantity: 1 }),
      });
      if (!response.ok) throw new Error('Add to cart failed');

      button.textContent = 'Added ✓';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      setTimeout(() => {
        button.textContent = originalLabel;
        button.disabled = false;
      }, 1800);
    } catch (error) {
      form.submit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  function initBlogSort() {
    document.querySelectorAll('[data-blog-sort]').forEach((bar) => {
      if (bar.dataset.bsReady) return;
      bar.dataset.bsReady = 'true';
      const grid = bar.closest('.blog').querySelector('[data-blog-grid]');
      if (!grid) return;
      const original = Array.from(grid.children);

      bar.querySelectorAll('[data-order]').forEach((btn) => {
        btn.addEventListener('click', () => {
          bar.querySelectorAll('[data-order]').forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          const items = btn.dataset.order === 'oldest' ? original.slice().reverse() : original;
          items.forEach((item) => grid.appendChild(item));
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogSort);
  } else {
    initBlogSort();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var H = { 'Content-Type': 'application/json', Accept: 'application/json' };

    // Shared cart-write queue + line-key resync, also used by delivery-date-picker.js.
    // Two facts drive this: (1) Shopify derives a line's key from its properties, so
    // every properties write (the subscription mirrors for gift card / dietary /
    // delivery date) gives that line a NEW key — a DOM row still holding the old key
    // then posts a stale id on the next +/−/remove (400 "no valid id or line
    // parameter") or, if the response no longer lists its key, gets dropped as
    // "removed". (2) /cart/change.js reads the whole cart and writes it back, so
    // overlapping writes clobber each other. So: all writes run one at a time through
    // enqueue(), and every response cart passes through sync() to re-key the rows.
    window.TCSCart = window.TCSCart || (function () {
      var chain = Promise.resolve();
      function enqueue(task) {
        var run = chain.then(function () { return task(); });
        chain = run.catch(function () {});
        return run;
      }
      function sync(cart) {
        if (!cart || !cart.items) return cart;
        var rows = Array.prototype.slice.call(document.querySelectorAll('[data-line-key]'));
        var taken = [];
        cart.items.forEach(function (item) {
          var plan = item.selling_plan_allocation ? String(item.selling_plan_allocation.selling_plan.id) : '';
          var row = rows.filter(function (r) { return taken.indexOf(r) === -1 && r.getAttribute('data-line-key') === item.key; })[0]
            || rows.filter(function (r) {
              return taken.indexOf(r) === -1
                && r.getAttribute('data-variant-id') === String(item.variant_id)
                && (r.getAttribute('data-selling-plan') || '') === plan;
            })[0];
          if (!row) return;
          taken.push(row);
          if (row.getAttribute('data-line-key') !== item.key) row.setAttribute('data-line-key', item.key);
          // Keep the visible quantity honest too — the next +/− adds to what's shown.
          var qtyEl = row.querySelector('.cart-line__qty-val');
          if (qtyEl && qtyEl.textContent !== String(item.quantity)) qtyEl.textContent = item.quantity;
        });
        return cart;
      }
      function fetchCart() {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(sync);
      }
      return { enqueue: enqueue, sync: sync, fetchCart: fetchCart };
    })();
    var TCSCart = window.TCSCart;

    function initCartPage() {
      var root = document.querySelector('[data-cart-page]');
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';

      var currency = root.getAttribute('data-currency') || 'GBP';
      var locale = document.documentElement.lang || 'en-GB';
      var threshold = parseInt(root.getAttribute('data-free-shipping-threshold'), 10) || 0;
      var formatter;
      try {
        formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
      } catch (e) {
        formatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
      }
      function money(cents) { return formatter.format((cents || 0) / 100); }

      function setHeaderCount(count) {
        document.querySelectorAll('.header__cart-count').forEach(function (badge) {
          badge.textContent = count;
          badge.classList.toggle('is-empty', count === 0);
        });
      }

      // Mirrors snippets/free-shipping-bar.liquid: a Cheese Club subscription line
      // carries free delivery for the whole order, so the bar reads "unlocked".
      function updateBar(total, hasSubscription) {
        var bar = root.querySelector('[data-ship-bar] .ship-bar');
        if (!bar || threshold <= 0) return;
        var msg = bar.querySelector('.ship-bar__msg');
        var fill = bar.querySelector('.ship-bar__fill');
        var thresholdCents = threshold * 100;
        var remaining = hasSubscription ? 0 : thresholdCents - total;
        if (hasSubscription) total = thresholdCents;
        if (msg) {
          if (hasSubscription) {
            msg.className = 'ship-bar__msg ship-bar__msg--done';
            msg.textContent = 'Free delivery included with your Cheese Club subscription';
          } else if (remaining > 0) {
            msg.className = 'ship-bar__msg';
            msg.innerHTML = "You're <strong>" + money(remaining) + '</strong> away from free delivery';
          } else {
            msg.className = 'ship-bar__msg ship-bar__msg--done';
            msg.textContent = "You've unlocked free delivery";
          }
        }
        if (fill) fill.style.width = Math.min(100, total / thresholdCents * 100) + '%';
      }

      function updateTotals(cart) {
        var sub = root.querySelector('[data-cart-subtotal]');
        if (sub) sub.textContent = money(cart.total_price);
        var title = root.querySelector('[data-cart-title]');
        if (title) {
          var base = title.getAttribute('data-base') || '';
          title.textContent = cart.item_count > 0 ? base + ' (' + cart.item_count + ')' : base;
        }
        setHeaderCount(cart.item_count);
        updateBar(cart.total_price, (cart.items || []).some(function (item) { return !!item.selling_plan_allocation; }));
      }

      // Shopify rejects quantity changes with a 422 + message (e.g. not
      // enough stock at a fulfilment location) — surface it rather than
      // silently failing or reloading.
      function showCartMessage(msg) {
        var el = root.querySelector('[data-cart-message]');
        if (!el) {
          el = document.createElement('p');
          el.className = 'cart-message';
          el.setAttribute('data-cart-message', '');
          el.setAttribute('role', 'status');
          var anchor = root.querySelector('[data-line-key]');
          var list = anchor && anchor.closest('ul');
          if (list && list.parentNode) list.parentNode.insertBefore(el, list);
          else root.insertBefore(el, root.firstChild);
        }
        el.textContent = msg;
        el.hidden = false;
        clearTimeout(el._hideTimer);
        el._hideTimer = setTimeout(function () { el.hidden = true; }, 5000);
      }

      // Quantity change for one row. Queued behind every other cart write, and the
      // key + quantity are read when the task RUNS (not when clicked), so a run of
      // quick +/+ clicks becomes 10→11→12 instead of three posts of 11, and a key
      // re-written by an earlier queued mirror is picked up. Belt and braces: a
      // stale-key rejection refreshes /cart.js, re-keys the rows and retries once.
      function change(row, delta) {
        return TCSCart.enqueue(function () {
          var valEl = row.querySelector('.cart-line__qty-val');
          var qty = delta === 0 ? 0 : Math.max(0, (valEl ? parseInt(valEl.textContent, 10) || 0 : 0) + delta);
          function post() {
            return fetch('/cart/change.js', { method: 'POST', headers: H,
              body: JSON.stringify({ id: row.getAttribute('data-line-key'), quantity: qty }) });
          }
          return post()
            .then(function (res) {
              if (res.status !== 400 && res.status !== 404) return res;
              var stale = row.getAttribute('data-line-key');
              return TCSCart.fetchCart().then(function () {
                return row.getAttribute('data-line-key') === stale ? res : post();
              });
            })
            .then(function (res) {
              if (!res.ok) {
                return res.json().catch(function () { return {}; }).then(function (err) {
                  showCartMessage(err.message || err.description || 'Sorry — that item can’t be updated right now.');
                  return null;
                });
              }
              return res.json();
            })
            .then(function (cart) {
              if (!cart) return;
              if (cart.item_count === 0) { window.location.reload(); return; }
              TCSCart.sync(cart);
              var key = row.getAttribute('data-line-key');
              var item = cart.items.filter(function (i) { return i.key === key; })[0];
              if (!item) {
                row.remove();
              } else {
                if (valEl) valEl.textContent = item.quantity;
                var price = row.querySelector('.cart-line__price');
                if (price) price.textContent = money(item.final_line_price);
              }
              updateTotals(cart);
            })
            .catch(function () { window.location.reload(); });
        });
      }

      root.addEventListener('click', function (event) {
        var add = event.target.closest('[data-upsell-add]');
        if (add) {
          event.preventDefault();
          add.disabled = true;
          fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ id: add.getAttribute('data-variant-id'), quantity: 1 }) })
            .then(function () { window.location.reload(); })
            .catch(function () { add.disabled = false; });
          return;
        }

        var row = event.target.closest('[data-line-key]');
        if (!row) return;

        if (event.target.closest('[data-qty-down]')) {
          event.preventDefault();
          change(row, -1);
        } else if (event.target.closest('[data-qty-up]')) {
          event.preventDefault();
          change(row, 1);
        } else if (event.target.closest('[data-remove]')) {
          event.preventDefault();
          change(row, 0);
        }
      });

      // Gift card + dietary are saved twice: as cart attributes (admin "Additional
      // details" + packing stickers on the FIRST order) and mirrored as line-item
      // properties on each subscription line — cart attributes never reach Appstle's
      // renewal orders, line properties are copied to every one. /cart/change.js
      // REPLACES a line's properties wholesale, so each write rebuilds them from a
      // fresh /cart.js snapshot to preserve "Requested first delivery" etc. Runs
      // through the shared queue, one line at a time, and re-keys the DOM rows from
      // each response (a properties write changes the line's key — see TCSCart).
      // onError (optional) receives Shopify's JSON error body for a rejected write —
      // the gift-card recipient properties are validated server-side (bad email etc.).
      function mirrorLineProps(propsToSet, wants, onError) {
        return TCSCart.enqueue(function () {
          return TCSCart.fetchCart()
            .then(function (cart) {
              var lines = (cart.items || []).filter(function (item) {
                if (!wants(item)) return false;
                var existing = item.properties || {};
                return Object.keys(propsToSet).some(function (k) {
                  return (existing[k] || '') !== (propsToSet[k] || '');
                });
              });
              return lines.reduce(function (p, item) {
                return p.then(function () {
                  var existing = item.properties || {};
                  var props = {};
                  Object.keys(existing).forEach(function (k) {
                    if (!(k in propsToSet)) props[k] = existing[k];
                  });
                  Object.keys(propsToSet).forEach(function (k) {
                    if (propsToSet[k]) props[k] = propsToSet[k];
                  });
                  // /cart/change.js IGNORES an empty properties object (verified
                  // 2026-09-06: {} / null / [] leave the old properties in place), so
                  // clearing the last property needs a stand-in. Underscore = hidden
                  // at checkout and in customer emails; admin sees a readable note.
                  if (!Object.keys(props).length) props = { '_Gift voucher': 'Email to buyer' };
                  // quantity MUST travel with a properties write: change.js without
                  // it resets the line to quantity 1 (observed live, 2026-09-04).
                  return fetch('/cart/change.js', { method: 'POST', headers: H, body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props }) })
                    .then(function (r) {
                      if (r.ok) return r.json().then(TCSCart.sync);
                      if (!onError) return null;
                      return r.json().then(onError, function () { onError({}); });
                    })
                    .catch(function () {});
                });
              }, Promise.resolve());
            })
            .catch(function () {});
        });
      }
      function mirrorSubscriptionProps(propsToSet) {
        return mirrorLineProps(propsToSet, function (item) { return !!item.selling_plan_allocation; });
      }

      // Gift VOUCHER lines — "This is a gift" panel (snippets/gift-voucher-recipient).
      // Writes Shopify's NATIVE gift-card recipient line-item properties onto every
      // voucher line, so Shopify emails the card to the recipient itself:
      //   __shopify_send_gift_card_to_recipient = true, Recipient name,
      //   Recipient email, Message. Unticked = all four removed (buyer gets the
      //   standard email). Shopify validates them on the write; a 422 is shown in
      //   the panel. Checkout submit waits for an in-flight write so the card
      //   can't leave without its recipient.
      function isVoucher(item) { return !!item.gift_card; }
      var RECIPIENT_KEYS = ['__shopify_send_gift_card_to_recipient', 'Recipient name', 'Recipient email', 'Message'];
      function clearedRecipient() {
        var p = {};
        RECIPIENT_KEYS.forEach(function (k) { p[k] = ''; });
        return p;
      }
      var recipient = root.querySelector('[data-gift-recipient]');
      var recipientPending = Promise.resolve();
      var rBusy = 0;       // writes in flight
      var rFailed = false; // last write rejected by Shopify (422)
      function rTrack(p) {
        rBusy++;
        recipientPending = p.then(function () { rBusy--; }, function () { rBusy--; });
        return recipientPending;
      }
      if (recipient) {
        var rToggle = recipient.querySelector('[data-gift-toggle]');
        var rFields = recipient.querySelector('[data-gift-fields]');
        var rError = recipient.querySelector('[data-gift-error]');
        var rInputs = Array.prototype.slice.call(recipient.querySelectorAll('[data-gift-field]'));
        function rShowError(msg) {
          rError.textContent = msg || '';
          rError.hidden = !msg;
        }
        function rValues() {
          var v = {};
          rInputs.forEach(function (el) { v[el.getAttribute('data-gift-field')] = el.value.trim(); });
          return v;
        }
        function rComplete(v) {
          var email = rInputs.filter(function (el) { return el.type === 'email'; })[0];
          return !!(v['Recipient name'] && v['Recipient email'] && (!email || email.checkValidity()));
        }
        function rWrite() {
          rShowError('');
          rFailed = false;
          if (!rToggle.checked) return rTrack(mirrorLineProps(clearedRecipient(), isVoucher));
          var v = rValues();
          // Only write once name + a valid email exist — Shopify rejects partials.
          if (!rComplete(v)) return Promise.resolve();
          return rTrack(mirrorLineProps({
            '_Gift voucher': '',
            '__shopify_send_gift_card_to_recipient': 'true',
            'Recipient name': v['Recipient name'],
            'Recipient email': v['Recipient email'],
            'Message': v['Message']
          }, isVoucher, function (err) {
            rFailed = true;
            var msg = (err && (err.description || err.message)) || 'Please check the recipient details.';
            if (err && err.errors && typeof err.errors === 'object') {
              var first = Object.keys(err.errors).map(function (k) { return err.errors[k]; })[0];
              if (first && first.length) msg = String(first[0]);
            }
            rShowError(msg);
          }));
        }
        function rSetRequired(on) {
          rInputs.forEach(function (el) {
            if (el.type === 'email' || el.getAttribute('data-gift-field') === 'Recipient name') {
              if (on) el.setAttribute('required', ''); else el.removeAttribute('required');
            }
          });
        }
        // Field visibility follows the checkbox — synced on load (the markup
        // ships hidden; a reload with recipient details on the line renders the
        // box checked) and on every change.
        function rSyncVisibility() {
          rFields.hidden = !rToggle.checked;
          rSetRequired(rToggle.checked);
        }
        rSyncVisibility();
        rToggle.addEventListener('change', function () {
          rSyncVisibility();
          recipient.classList.remove('needs-attention');
          rWrite();
          if (rToggle.checked) {
            var first = rInputs[0];
            if (first && !first.value) first.focus();
          }
        });
        rInputs.forEach(function (el) { el.addEventListener('change', rWrite); });

        // Checkout: block while the recipient details are incomplete or Shopify
        // rejected them; otherwise let an in-flight properties write finish before
        // the form leaves the page. Native submit is left alone whenever nothing is
        // pending, and never overridden while the date picker's own gate would block.
        var rForm = recipient.closest('form');
        var rSubmitting = false;
        function rAttention() {
          recipient.classList.add('needs-attention');
          recipient.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (rForm) {
          rForm.addEventListener('submit', function (e) {
            if (rSubmitting || e.defaultPrevented) return;
            if (rToggle.checked && (rFailed || !rComplete(rValues()))) {
              e.preventDefault();
              rAttention();
              return;
            }
            if (!rBusy) return;
            var pickerConfirm = rForm.querySelector('[data-delivery-picker] [data-confirm]');
            if (pickerConfirm && !pickerConfirm.checked) return;
            e.preventDefault();
            rSubmitting = true;
            // Re-submit WITH the checkout button: form.submit() drops the submitter,
            // and a /cart POST without name="checkout" is just a cart update that
            // reloads the basket (seen live 2026-09-06 — "submit twice to check out").
            var submitter = e.submitter || rForm.querySelector('[name="checkout"]');
            recipientPending.then(function () {
              if (rFailed) { rSubmitting = false; rAttention(); return; }
              if (typeof rForm.requestSubmit === 'function' && submitter) {
                rForm.requestSubmit(submitter);
              } else {
                var hidden = document.createElement('input');
                hidden.type = 'hidden';
                hidden.name = 'checkout';
                hidden.value = 'Checkout';
                rForm.appendChild(hidden);
                rForm.submit();
              }
            });
          });
        }
      }

      var giftcard = root.querySelector('[data-giftcard]');
      var dietary = root.querySelector('[data-dietary]');

      if (giftcard) {
        // Title value + big card follow the checked tile (tile dimming is pure
        // CSS via :has(:checked)).
        function syncGiftSummary(input) {
          var nameEl = root.querySelector('[data-gift-name]');
          if (nameEl) nameEl.textContent = input.value;
          var tileImg = input.closest('.gift-picker__tile').querySelector('img');
          var mainImg = root.querySelector('.gift-picker__main-img');
          if (tileImg && mainImg) {
            mainImg.srcset = tileImg.srcset;
            mainImg.sizes = mainImg.sizes || tileImg.sizes;
            mainImg.src = tileImg.currentSrc || tileImg.src;
            mainImg.alt = input.value;
          }
        }

        // Attribute save FIRST, mirror only after it commits: firing them in
        // parallel is a real race — /cart/change.js reads the whole cart and
        // writes it back, resurrecting the attribute state it read whenever
        // update.js hadn't committed yet (observed live while clearing dietary).
        giftcard.addEventListener('change', function (event) {
          var input = event.target.closest('input[name="attributes[Gift Card]"]');
          if (!input) return;
          syncGiftSummary(input);
          TCSCart.enqueue(function () {
            return fetch('/cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ attributes: { 'Gift Card': input.value } }) })
              .catch(function () {});
          }).then(function () { mirrorSubscriptionProps({ 'Gift Card': input.value }); });
        });
      }

      if (dietary) {
        // Same sequencing as the gift card (see comment above).
        dietary.addEventListener('change', function () {
          saveCartAttributes().then(function () {
            mirrorSubscriptionProps({ 'Dietary / Allergy': dietary.value });
          });
        });
      }

      // Allergies dropdown (summary card): opens UPWARD as an overlay so the card
      // never resizes — the panel lays over the date picker while open. MULTI-
      // SELECT: each click toggles one option and the panel stays open; the
      // hidden [data-dietary] input holds the ticked labels joined ", " in list
      // order. "No allergies" (empty value) clears everything. The change event
      // (which the attribute-save + subscription-mirror listeners above handle)
      // is debounced so a run of quick ticks becomes one save, and flushed the
      // moment the panel closes so nothing is left pending at checkout.
      var dietaryDrop = root.querySelector('[data-dietary-drop]');
      if (dietaryDrop && dietary) {
        var ddBtn = dietaryDrop.querySelector('[data-dietary-btn]');
        var ddPanel = dietaryDrop.querySelector('[data-dietary-panel]');
        var ddValue = dietaryDrop.querySelector('[data-dietary-value]');
        var ddOpts = Array.prototype.slice.call(dietaryDrop.querySelectorAll('[data-dietary-opt]'));
        var ddNone = ddOpts.filter(function (o) { return !o.getAttribute('data-value'); })[0];
        var ddTimer = null;
        var ddFlush = function () {
          if (ddTimer === null) return;
          clearTimeout(ddTimer);
          ddTimer = null;
          dietary.dispatchEvent(new Event('change', { bubbles: true }));
        };
        var ddToggle = function (open) {
          ddPanel.hidden = !open;
          ddBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (!open) ddFlush();
        };
        var ddSync = function () {
          var picked = ddOpts.filter(function (o) {
            return o.getAttribute('data-value') && o.getAttribute('aria-selected') === 'true';
          }).map(function (o) { return o.getAttribute('data-value'); });
          var val = picked.join(', ');
          if (ddNone) ddNone.setAttribute('aria-selected', val ? 'false' : 'true');
          ddValue.textContent = val || 'Any allergies or dietary needs?';
          ddValue.classList.toggle('is-placeholder', !val);
          if (dietary.value === val) return;
          dietary.value = val;
          clearTimeout(ddTimer);
          ddTimer = setTimeout(function () { ddTimer = null; dietary.dispatchEvent(new Event('change', { bubbles: true })); }, 400);
        };
        ddBtn.addEventListener('click', function () { ddToggle(ddPanel.hidden); });
        dietaryDrop.addEventListener('click', function (e) {
          if (e.target.closest('[data-dietary-done]')) { ddToggle(false); ddBtn.focus(); return; }
          var opt = e.target.closest('[data-dietary-opt]');
          if (!opt) return;
          if (!opt.getAttribute('data-value')) {
            ddOpts.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
          } else {
            opt.setAttribute('aria-selected', opt.getAttribute('aria-selected') === 'true' ? 'false' : 'true');
          }
          ddSync();
        });
        document.addEventListener('click', function (e) {
          if (!ddPanel.hidden && !dietaryDrop.contains(e.target)) ddToggle(false);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !ddPanel.hidden) { ddToggle(false); ddBtn.focus(); }
        });
        // Belt and braces: if the customer hits checkout with the panel still
        // open, the form already carries the hidden input's value; this just
        // makes sure the subscription-line mirror isn't skipped.
        var cartForm = dietary.closest('form');
        if (cartForm) cartForm.addEventListener('submit', ddFlush);
      }

      // Defaults are pre-selected server-side without any change event, and a
      // subscription added after a choice was made carries no properties yet —
      // back-fill both in ONE pass per line on load. Delayed so the date picker's
      // own load-time back-fill (which also rebuilds line properties from its
      // snapshot) lands first instead of racing it.
      if (giftcard || dietary) {
        setTimeout(function () {
          // Read the CURRENT values at fire time — capturing them at load would
          // overwrite a change the customer makes during the delay.
          var backfill = {};
          var checkedCard = giftcard && giftcard.querySelector('input[name="attributes[Gift Card]"]:checked');
          if (checkedCard) backfill['Gift Card'] = checkedCard.value;
          if (dietary) backfill['Dietary / Allergy'] = dietary.value;
          if (Object.keys(backfill).length) mirrorSubscriptionProps(backfill);
          // One-off tidy: voucher lines added before 2026-09-06 may still carry the
          // retired greeting-card mirror (Gift Card / _Gift card image / Gift message).
          mirrorLineProps({ 'Gift Card': '', '_Gift card image': '', 'Gift message': '' }, isVoucher);
        }, 1200);
      }

      // Send every attribute field's value in one update: cart attribute
      // writes are last-write-wins server-side, so concurrent single-key
      // posts can drop each other.
      function saveCartAttributes() {
        return TCSCart.enqueue(function () {
          var attrs = {};
          root.querySelectorAll('[data-cart-attribute]').forEach(function (f) {
            attrs[f.getAttribute('data-cart-attribute')] = f.value;
          });
          return fetch('/cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
        });
      }
      root.querySelectorAll('[data-cart-attribute]').forEach(function (field) {
        // The dietary input sequences its own save + mirror (listener above) —
        // binding it here too would race a second update.js against that chain.
        if (field.hasAttribute('data-dietary')) return;
        field.addEventListener('change', saveCartAttributes);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartPage);
    } else {
      initCartPage();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    function initFilters() {
      document.querySelectorAll('[data-filter-form]').forEach(function (form) {
        if (form.dataset.filterReady) return;
        form.dataset.filterReady = 'true';
        form.addEventListener('change', function (event) {
          if (event.target.closest('[data-auto-submit]')) {
            form.submit();
          }
        });
      });

      // Desktop: hold the FILTER BY wrapper open so the dropdown row shows
      // inline; mobile keeps native <details> toggling (works without JS too).
      document.querySelectorAll('[data-filters-wrap]').forEach(function (wrap) {
        if (wrap.dataset.wrapReady) return;
        wrap.dataset.wrapReady = 'true';
        var mq = window.matchMedia('(min-width: 750px)');
        var sync = function () {
          if (mq.matches) wrap.setAttribute('open', '');
        };
        sync();
        if (mq.addEventListener) mq.addEventListener('change', sync);
      });

      // Accordion behaviour: opening one filter dropdown closes the others.
      document.querySelectorAll('.collection-filters').forEach(function (bar) {
        if (bar.dataset.accordionReady) return;
        bar.dataset.accordionReady = 'true';
        bar.querySelectorAll('details.collection-filter').forEach(function (details) {
          details.addEventListener('toggle', function () {
            if (!details.open) return;
            bar.querySelectorAll('details.collection-filter[open]').forEach(function (other) {
              if (other !== details) other.removeAttribute('open');
            });
          });
        });
      });
    }

    // Fetch-and-append the next page. Returns true while more pages remain.
    var loadingNext = false;
    async function loadNext(link) {
      if (loadingNext) return true;
      loadingNext = true;

      var url = link.getAttribute('href');
      link.classList.add('is-loading');

      try {
        var response = await fetch(url);
        if (!response.ok) throw new Error('Load more failed');
        var html = await response.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var currentGrid = document.querySelector('[data-product-grid]');
        var newGrid = doc.querySelector('[data-product-grid]');
        if (currentGrid && newGrid) {
          while (newGrid.firstElementChild) {
            currentGrid.appendChild(newGrid.firstElementChild);
          }
        }

        var newLink = doc.querySelector('[data-load-more]');
        if (newLink) {
          link.setAttribute('href', newLink.getAttribute('href'));
          link.classList.remove('is-loading');
          return true;
        }
        var wrapper = link.closest('.collection-more');
        if (wrapper) wrapper.remove();
        return false;
      } catch (error) {
        window.location.href = url;
        return false;
      } finally {
        loadingNext = false;
      }
    }

    function onClick(event) {
      var link = event.target.closest('[data-load-more]');
      if (!link) return;
      event.preventDefault();
      loadNext(link);
    }

    // Seamless pagination: hide the See more link, top the grid up to the
    // configured initial count, then auto-load pages as the sentinel nears
    // the viewport. The link stays in the DOM as the next-page URL + no-JS
    // fallback.
    function initSeamless() {
      var wrapper = document.querySelector('.collection-more');
      var grid = document.querySelector('[data-product-grid]');
      if (!wrapper || !grid || !('IntersectionObserver' in window)) return;
      if (wrapper.dataset.seamlessReady) return;
      wrapper.dataset.seamlessReady = 'true';
      wrapper.classList.add('is-seamless');

      var initial = parseInt(grid.dataset.initial, 10) || 0;
      var nextLink = function () {
        return document.querySelector('[data-load-more]');
      };

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var link = nextLink();
            if (link) loadNext(link);
          });
        },
        { rootMargin: '600px 0px' }
      );
      observer.observe(wrapper);

      (async function topUp() {
        var link = nextLink();
        while (link && grid.children.length < initial) {
          var hasMore = await loadNext(link);
          if (!hasMore) break;
          link = nextLink();
        }
      })();
    }

    // Single-variant cards (e.g. gift boxes) add straight to cart and open the
    // drawer via cart:refresh; falls back to a native submit on failure.
    async function onAddToCart(event) {
      var form = event.target.closest('[data-product-add]');
      if (!form) return;
      event.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      var idInput = form.querySelector('input[name="id"]');
      if (!button || !idInput) {
        form.submit();
        return;
      }

      var original = button.textContent;
      button.disabled = true;

      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: 1 }),
        });
        if (!response.ok) throw new Error('Add to cart failed');
        button.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
        }, 1800);
      } catch (error) {
        form.submit();
      }
    }

    function init() {
      initFilters();
      initSeamless();
      document.addEventListener('click', onClick);
      document.addEventListener('submit', onAddToCart);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initHeaderDrawer() {
    document.querySelectorAll('.header-wrap').forEach((wrap) => {
      const toggle = wrap.querySelector('.header__menu-toggle');
      const drawer = wrap.querySelector('.header__drawer');
      if (!toggle || !drawer || toggle.dataset.drawerReady) return;
      toggle.dataset.drawerReady = 'true';

      toggle.addEventListener('click', () => {
        if (typeof drawer.showModal === 'function') {
          drawer.showModal();
        } else {
          drawer.setAttribute('open', '');
        }
        toggle.setAttribute('aria-expanded', 'true');
      });

      const closeDrawer = () => {
        if (typeof drawer.close === 'function') {
          drawer.close();
        } else {
          drawer.removeAttribute('open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      };

      const closeButton = drawer.querySelector('[data-drawer-close]');
      if (closeButton) closeButton.addEventListener('click', closeDrawer);

      drawer.addEventListener('click', (event) => {
        if (event.target === drawer) closeDrawer();
      });

      drawer.addEventListener('close', () => {
        toggle.setAttribute('aria-expanded', 'false');
      });

      drawer.querySelectorAll('a[href]').forEach((anchor) => {
        anchor.addEventListener('click', closeDrawer);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderDrawer);
  } else {
    initHeaderDrawer();
  }

  (function () {
    function initDeliveryPill() {
      var el = document.querySelector('[data-delivery-pill]');
      var dataEl = document.getElementById('delivery-settings-data');
      if (!el || !dataEl || !window.TCSDelivery) return;
      var opts;
      try { opts = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var res = window.TCSDelivery.computeAvailability(new Date(), opts);
      if (!res.floor) return;
      var d = new Date(res.floor + 'T00:00:00Z');
      /* "Tuesday 1 Sep" — built by hand: en-GB toLocaleDateString abbreviates
         September as "Sept", and the design wants a strict 3-letter month. */
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      el.textContent = days[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + months[d.getUTCMonth()];
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDeliveryPill);
    else initDeliveryPill();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  function initHeroSliders() {
    document.querySelectorAll('[data-hero]').forEach((hero) => {
    if (hero.dataset.heroReady) return;
    const track = hero.querySelector('.hero__track');
    const slides = Array.from(hero.querySelectorAll('.hero__slide'));
    const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
    if (!track || slides.length < 2) return;
    hero.dataset.heroReady = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    let timer = null;

    const setCurrent = (n) => {
      index = (n + slides.length) % slides.length;
      dots.forEach((d, i) => d.setAttribute('aria-current', i === index ? 'true' : 'false'));
    };

    const goTo = (n, smooth = true) => {
      setCurrent(n);
      track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    };

    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const start = () => {
      if (reduceMotion || timer) return;
      timer = setInterval(() => goTo(index + 1), 6000);
    };
    const restart = () => { stop(); start(); };

    dots.forEach((dot, i) => dot.addEventListener('click', () => { goTo(i); restart(); }));

    let scrollDebounce = null;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(() => setCurrent(Math.round(track.scrollLeft / track.clientWidth)), 120);
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);

    setCurrent(0);
    start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroSliders);
  } else {
    initHeroSliders();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monthly-selection"]) return;
  try {
    
  (function () {
    function initDeliveryMonth() {
      var els = document.querySelectorAll('[data-delivery-month]');
      if (!els.length) return;
      var dataEl = document.getElementById('delivery-settings-data');
      if (!dataEl || !window.TCSDelivery) return;
      var opts;
      try { opts = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var res = window.TCSDelivery.computeAvailability(new Date(), opts);
      if (!res.floor) return;
      var d = new Date(res.floor + 'T00:00:00Z');
      var month = d.toLocaleDateString('en-GB', { month: 'long', timeZone: 'UTC' });
      els.forEach(function (el) { el.textContent = month; });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDeliveryMonth);
    else initDeliveryMonth();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function initProduct(root) {
      if (root.dataset.productReady) return;
      root.dataset.productReady = 'true';

      // Gallery: swap the main image when a thumbnail is clicked.
      // (Selected by class: image_tag silently drops data-* keyword attributes,
      // so [data-main-image] never reaches the DOM.)
      var mainImage = root.querySelector('.product__main-image');
      root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          if (mainImage && full) {
            mainImage.src = full;
            mainImage.removeAttribute('srcset');
          }
          root.querySelectorAll('[data-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      });

      // Price headline = selected variant price × quantity (accumulated).
      var priceDisplay = root.querySelector('[data-price-display]');
      var priceEl = root.querySelector('[data-price]');
      var unitEl = root.querySelector('[data-price-unit]');
      var currency = (priceDisplay && priceDisplay.getAttribute('data-currency')) || 'GBP';
      var qty = root.querySelector('[data-qty-input]');

      function formatMoney(cents) {
        try {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2);
        }
      }

      function currentVariantInput() {
        return root.querySelector('input[name="id"]:checked') || root.querySelector('input[name="id"]');
      }

      function updatePrice() {
        var input = currentVariantInput();
        if (!input || !priceEl) return;
        var cents = parseInt(input.getAttribute('data-price-cents'), 10) || 0;
        var quantity = Math.max(1, parseInt(qty && qty.value, 10) || 1);
        priceEl.textContent = formatMoney(cents * quantity);
        var title = input.getAttribute('data-title') || '';
        if (unitEl) {
          unitEl.textContent = quantity > 1 ? quantity + ' × ' + title : 'per ' + title;
        }
        var per100El = root.querySelector('[data-price-per100]');
        if (per100El) {
          var grams = parseInt(title.toLowerCase().replace(/g\s*$/, ''), 10);
          if (grams > 0 && /^\d+g$/i.test(title.trim())) {
            per100El.textContent = '(' + formatMoney(Math.round((cents * 100) / grams)) + ' per 100g)';
            per100El.hidden = false;
          } else {
            per100El.hidden = true;
          }
        }
      }

      root.querySelectorAll('[data-variant]').forEach(function (input) {
        input.addEventListener('change', updatePrice);
      });

      // Quantity steppers.
      var down = root.querySelector('[data-qty-down]');
      var up = root.querySelector('[data-qty-up]');
      if (qty && down) down.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
        updatePrice();
      });
      if (qty && up) up.addEventListener('click', function () {
        qty.value = (parseInt(qty.value, 10) || 1) + 1;
        updatePrice();
      });
      if (qty) qty.addEventListener('input', updatePrice);

      // Add to basket via fetch; opens the cart drawer. Falls back to native submit.
      var form = root.querySelector('[data-product-form]');
      if (form) {
        form.addEventListener('submit', async function (event) {
          var button = form.querySelector('.product__add');
          var checked = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
          if (!checked) return;
          event.preventDefault();

          var original = button ? button.textContent : '';
          if (button) button.disabled = true;

          try {
            var response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: checked.value, quantity: parseInt(qty && qty.value, 10) || 1 }),
            });
            if (!response.ok) throw new Error('Add to cart failed');
            if (button) button.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function () {
              if (button) { button.textContent = original; button.disabled = false; }
            }, 1800);
          } catch (error) {
            form.submit();
          }
        });
      }
    }

    function init() {
      document.querySelectorAll('.product').forEach(initProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-cheese"] && !Shopify.designMode) return;
  try {
    
  function initShopCheeseSliders() {
    document.querySelectorAll('.shop-cheese').forEach((section) => {
      const grid = section.querySelector('.shop-cheese__grid');
      const nav = section.querySelector('[data-shop-cheese-nav]');
      if (!grid || !nav || grid.dataset.scReady) return;
      grid.dataset.scReady = 'true';

      const stepDistance = () => {
        const item = grid.querySelector('.shop-cheese__item');
        const width = item ? item.getBoundingClientRect().width : grid.clientWidth / 2;
        return (width + 20) * 2;
      };

      nav.querySelectorAll('[data-dir]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const direction = btn.dataset.dir === 'next' ? 1 : -1;
          grid.scrollBy({ left: direction * stepDistance(), behavior: 'smooth' });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopCheeseSliders);
  } else {
    initShopCheeseSliders();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staff-favourites"] && !Shopify.designMode) return;
  try {
    
  function initStaffFavs() {
    document.querySelectorAll('[data-staff-favs]').forEach((carousel) => {
      const track = carousel.querySelector('.staff-favs__track');
      if (!track || track.dataset.sfReady) return;
      track.dataset.sfReady = 'true';

      const step = () => {
        const item = track.querySelector('.staff-favs__item');
        const width = item ? item.getBoundingClientRect().width : track.clientWidth / 2;
        return width + 40;
      };

      carousel.querySelectorAll('[data-dir]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const direction = btn.dataset.dir === 'next' ? 1 : -1;
          track.scrollBy({ left: direction * step(), behavior: 'smooth' });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStaffFavs);
  } else {
    initStaffFavs();
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.staff-favs [data-product-add]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const idInput = form.querySelector('input[name="id"]');
    if (!button || !idInput) {
      form.submit();
      return;
    }

    const originalLabel = button.textContent;
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: idInput.value, quantity: 1 }),
      });
      if (!response.ok) throw new Error('Add to cart failed');

      button.textContent = 'Added ✓';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      setTimeout(() => {
        button.textContent = originalLabel;
        button.disabled = false;
      }, 1800);
    } catch (error) {
      form.submit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-product"]) return;
  try {
    
  function initSubscriptionGalleries() {
    document.querySelectorAll('[data-sub-gallery]').forEach((gallery) => {
      if (gallery.dataset.subReady) return;
      gallery.dataset.subReady = 'true';
      const main = gallery.querySelector('[data-sub-main-image]');
      if (!main) return;

      gallery.querySelectorAll('[data-sub-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const full = thumb.dataset.full;
          if (full) main.src = full;
          gallery.querySelectorAll('[data-sub-thumb]').forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function initSubscriptionForms() {
    document.querySelectorAll('[data-sub-form]').forEach((form) => {
      if (form.dataset.subFormReady) return;
      form.dataset.subFormReady = 'true';

      const button = form.querySelector('[data-sub-add]');
      const errorEl = form.querySelector('[data-sub-error]');

      // True once the app widget has written a plan ID into a selling_plan input (ours or its own).
      function hasSellingPlan() {
        return Array.from(form.querySelectorAll('[name="selling_plan"]')).some((el) => el.value);
      }

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (!hasSellingPlan()) {
          if (errorEl) errorEl.hidden = false;
          return;
        }
        if (errorEl) errorEl.hidden = true;

        const original = button ? button.textContent : '';
        if (button) button.disabled = true;

        // Omit empty line-item properties (e.g. a blank delivery date) from the payload.
        const emptyProps = Array.from(form.querySelectorAll('input[name^="properties"]')).filter((el) => !el.value);
        emptyProps.forEach((el) => { el.disabled = true; });
        const body = new FormData(form);
        emptyProps.forEach((el) => { el.disabled = false; });

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: body,
          });
          if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error(data.description || 'Add to cart failed');
          }
          if (button) button.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(() => {
            if (button) { button.textContent = original; button.disabled = false; }
          }, 1800);
        } catch (error) {
          // Native submit fallback so the customer can still complete the purchase.
          form.submit();
        }
      });
    });
  }

  function initSubscriptionProduct() {
    initSubscriptionGalleries();
    initSubscriptionForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSubscriptionProduct);
  } else {
    initSubscriptionProduct();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  // Autoplay for the testimonial slider: every 10 s scroll on by one full
  // view (3 quotes on desktop, 1 on mobile), loop back to the start after
  // the last view, pause while hovered/focused, and stay still under
  // prefers-reduced-motion. Manual swipes/scrolls are respected: the timer
  // simply resumes from wherever the user left the track.
  function initTestimonialSliders() {
    document.querySelectorAll('[data-testimonials]').forEach((section) => {
      if (section.dataset.testimonialsReady) return;
      const track = section.querySelector('[data-testimonials-track]');
      if (!track) return;
      section.dataset.testimonialsReady = 'true';

      // Newest first: metaobject ids rise with creation.
      Array.from(track.querySelectorAll('[data-entry-id]'))
        .sort((a, b) => Number(b.dataset.entryId) - Number(a.dataset.entryId))
        .forEach((item) => track.appendChild(item));
      track.scrollLeft = 0;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const INTERVAL = 10000;
      let timer = null;

      const next = () => {
        const maxLeft = track.scrollWidth - track.clientWidth;
        if (maxLeft <= 1) return;
        // One "view" = the visible width; align to the next snap point past it.
        const target = track.scrollLeft + track.clientWidth;
        track.scrollTo({ left: target >= maxLeft - 1 ? 0 : target, behavior: 'smooth' });
      };

      const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
      const start = () => {
        if (reduceMotion || timer) return;
        timer = setInterval(next, INTERVAL);
      };

      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', start);
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('touchend', start, { passive: true });

      start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialSliders);
  } else {
    initTestimonialSliders();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voucher-options"]) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-voucher-add]');
    if (!form) return;
    event.preventDefault();

    const idField = form.querySelector('[name="id"]');
    const qtyField = form.querySelector('[name="quantity"]');
    const button = form.querySelector('button[type="submit"]');
    if (!idField) {
      form.submit();
      return;
    }

    const original = button ? button.textContent : '';
    if (button) button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: idField.value, quantity: parseInt(qtyField && qtyField.value, 10) || 1 }),
      });
      if (!response.ok) throw new Error('Add to cart failed');
      if (button) button.textContent = 'Added ✓';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(() => {
        if (button) { button.textContent = original; button.disabled = false; }
      }, 1800);
    } catch (error) {
      form.submit();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
